<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>钻头趟数</el-breadcrumb-item>
      <el-breadcrumb-item>详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel">
          <el-page-header @back="$router.go(-1)" content="钻头趟数详情">
          </el-page-header>
          <div class="panel-body">
            <dl class="dl-horizontal" v-if="drill_trip.id">
              <dt>区域</dt>
              <dd>{{ drill_trip.region_info.name }}</dd>
              <dt>井队</dt>
              <dd>{{ drill_trip.pit_team }}</dd>
              <dt>井号</dt>
              <dd>{{ drill_trip.pit_number }}</dd>

              <dt class="dl-title"></dt>
              <dd></dd>
              <dt>型号</dt>
              <dd>{{ drill_trip.model_number }}</dd>
              <dt>序列号</dt>
              <dd><DrillLink :no="drill_trip.serial_number"></DrillLink></dd>
              <dt>尺寸(mm)</dt>
              <dd>{{ drill_trip.size }}</dd>

              <dt class="dl-title"></dt>
              <dd></dd>
              <dt>入井时间</dt>
              <dd>{{ drill_trip.enter_time }}</dd>
              <dt>出井时间</dt>
              <dd>{{ drill_trip.out_time }}</dd>
              <dt>钻进井段(m)</dt>
              <dd>
                {{ drill_trip.enter_pit_depth }} -
                {{ drill_trip.out_pit_depth }}
              </dd>
              <dt>进尺(m)</dt>
              <dd>{{ drill_trip.drill_footage }}</dd>
              <dt>所钻地层</dt>
              <dd>{{ drill_trip.stratum }}</dd>
              <dt>纯钻时间(h)</dt>
              <dd>{{ drill_trip.drill_time }}</dd>
              <dt>机械钻速(m/h)</dt>
              <dd>{{ drill_trip.drill_speed }}</dd>

              <dt class="dl-title">钻进参数</dt>
              <dd></dd>
              <dt>钻压(kN)</dt>
              <dd>{{ drill_trip.drill_presure }}</dd>
              <dt>转速(r/min)</dt>
              <dd>{{ drill_trip.rotationl_speed }}</dd>
              <dt>排量(L/S)</dt>
              <dd>{{ drill_trip.displacement }}</dd>
              <dt>泵压(MPa)</dt>
              <dd>{{ drill_trip.pumping_pressure }}</dd>

              <dt class="dl-title"></dt>
              <dd></dd>
              <dt>备注</dt>
              <dd v-html="drill_trip.remark"></dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { drillTripDetail } from '../../../service/getData'

export default {
  data() {
    return {
      drill_trip: {},
    }
  },
  created() {
    this.getData(this.$route.params.id)
  },
  methods: {
    async getData(id) {
      let res = await drillTripDetail(id)
      this.drill_trip = res.data
    },
  },
}
</script>